import setup from './moduleSetup';

export default {
    name: 'mainLayout',
    before: [],
    after: [],
    setup,
};
